<template>
  <div class="container">
    <!-- 头部区域 -->
    <header>
      <div class="header_content"><span class="titTop">项目详情</span></div>
      <div class="goback"
           @click="goback">
        <img src="../../assets/socialOrg/goback.png"
             alt="" />
        <span>返回</span>
      </div>
    </header>
    <!-- 中部区域 -->
    <div class="center_box">
      <!-- 表格 -->
      <div class="table">
        <div class="bigrow">
          <div class="bigrow_tit1">{{ projectName }}</div>
        </div>
        <div class="row">
          <div class="item">
            <div class="itemWord">
              <div class="itemT">发包方:</div>
              <div class="itemcontent">
                {{ govName }}
              </div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">项目金额(万):</div>
              <div class="itemcontent">{{ projectBudget }}</div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">项目时间:</div>
              <div class="itemcontent">{{ projectTime }}</div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">项目类别:</div>
              <div class="itemcontent">{{ projectCategory }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <div class="itemWord">
              <div class="itemT">报名时间:</div>
              <div class="itemcontent">{{ recruitTime }}</div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">已报名社会组织数量:</div>
              <div class="itemcontent">{{ signUpCount }}</div>
            </div>
          </div>
          <div class="item"></div>
          <div class="item"></div>
        </div>
      </div>
      <!-- 介绍 -->
      <div class="introduceBox">
        <div class="introLeft">
          <div class="introTit">介绍</div>
          <div class="introCon">
            {{ projectIntroduction }}
          </div>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="nav">
      <div :class="[selectIndex == index1 ? 'navItem leftA' : 'navItem leftD']"
           class="navItem"
           @click="select(index1)">
        已申报的社会组织( {{ sbTotal }} )
      </div>
      <div :class="[selectIndex == index2 ? 'navItem rightA' : 'navItem rightD']"
           class="navItem"
           @click="select(index2)">
        已承接的社会组织( {{ cjTotal }} )
      </div>
    </div>
    <div class="listBox">
      <div v-if="selectIndex == 0 && total > 0"
           class="list">
        <div v-for="(item, index) in projectList"
             :key="index"
             class="item">
          <div class="itemWord1">{{ item.orgName }}</div>
          <div class="itemWord2"
               style="margin-right: 30px">
            <img src="../../assets/socialOrg/smallimg.png"
                 alt="" />
            <span>{{ item.address }}</span>
          </div>
          <!-- <div v-if="item.projectStatus==1" class="itemWord3">已结项</div>
        <div v-else class="itemWord3">已结项</div> -->
        </div>
      </div>
      <div v-if="selectIndex == 1 && total > 0"
           class="list">
        <!--   -->
        <div class="item"
             v-for="(item, index) in projectList"
             :key="index">
          <div class="itemWord1">{{ item.orgName }}</div>
          <div class="itemWord2"
               style="margin-right: 30px">
            <img src="../../assets/socialOrg/smallimg.png"
                 alt="" />
            <span>{{ item.address }}</span>
          </div>
          <!-- <div v-if="item.projectStatus==1" class="itemWord3">已结项</div>
        <div v-else class="itemWord3">已结项~</div> -->
        </div>
      </div>
      <div v-if="total == 0"
           style="
          color: #ffe1ce;
          font-size: 35px;
          font-weight: 600;
          margin-top: 80px;
        ">
        暂无相关数据
      </div>
    </div>

    <Pagination v-if="total > 0"
                style="bottom: 40px"
                :total="total"
                :size="2"
                :page="listQuery.page"
                @pagination="fetchData" />
  </div>
</template>

<script>
import Pagination from "@/components/pagination";
import {
  selectSignUpOrgNotGenerate,
  selectSignUpOrgGenerate,
  selectKyyProjectDetail,
} from "../../config/details";
export default {
  components: { Pagination },
  data () {
    return {
      // orgId:1406,
      projectList: [],
      // selectId: {
      //   projectId: null,
      // },
      total: 0,
      selectIndex: 0,
      index1: 0,
      index2: 1,
      dataArr: {
        type1: [34, 81, 80, 28, 17],
        type2: [50, 8, 67, 28, 27],
      },
      navArr: [
        { navname: "项目", num: 99 },
        { navname: "活动", num: 76 },
      ],
      projectName: "",
      govName: "", 
      projectBudget: "",
      projectIntroduction: "",
      projectTime: "",
      recruitTime: "",
      projectCategory: "",
      signUpCount: "",

      listQuery: {
        page: 1,
        limit: 2,
        projectId: '',
      },
      sbTotal: "",
      cjTotal: "",
    };
  },
  mounted () {
    // const id = this.$route.query && this.$route.query.id;
    // console.log("this.$route.query.id=>", this.$route.query.id);
    // this.selectId.projectId = 21;
    this.listQuery.projectId = this.$route.query.id;
    this.getDetails();
    this.getsbTotal();
    this.getcjTotal();
    this.fetchData(1);
  },
  methods: {
    select (index) {
      this.selectIndex = index;
      this.listQuery.page = 1;
      this.fetchData(1);
    },

    async getsbTotal () {
      const res = await this.postRequest(
        selectSignUpOrgNotGenerate,
        this.listQuery
      );
      console.log("res==>", res);
      if (res.rtnCode == "0000") {
        this.sbTotal = res.data.total;
      }
    },
    async getcjTotal () {
      const res = await this.postRequest(
        selectSignUpOrgGenerate,
        this.listQuery
      );
      console.log("res==>", res);
      if (res.rtnCode == "0000") {
        this.cjTotal = res.data.total;
      }
    },

    /**
     * 获取所有数据的方法
     */
    async getDetails () {
      const res = await this.postRequest(selectKyyProjectDetail, {
        projectId:this.$route.query.id, // 临时数据
      });
      console.log("res==>", res);
      if (res.rtnCode == "0000") {
        this.projectName = res.data.projectName; //项目名称
        this.govName = res.data.govName; //项目名称
        this.projectBudget = parseFloat(res.data.projectBudget); //项目名称
        this.projectTime = res.data.projectTime; //项目名称
        this.recruitTime = res.data.recruitTime; //项目名称
        this.projectCategory = res.data.projectCategory; //项目名称
        this.signUpCount = res.data.signUpCount; //项目名称
        this.projectIntroduction = res.data.projectIntroduction;
      }
    },
    //获取列表数据
    async fetchData (e) {
      console.log('e',e)
      let url;
      console.log("this.selectIndex==>",this.selectIndex)
      if (this.selectIndex == 0) {
        url = selectSignUpOrgNotGenerate;
      } else {
        url = selectSignUpOrgGenerate;
      }
      this.listQuery.page = e;
      const res = await this.postRequest(url, this.listQuery);
      console.log("res==>", res);
      if (res.rtnCode == "0000") {
        this.projectList = res.data.list;
        this.total = res.data.total;
        console.log('res.data.total->',res.data.total)
      }
    },
    // 返回上一页
    goback () {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
@rowHeight: 80px; //表格每一行的行高
@bigrowHeight: 150px; //表格每一大行的行高
@centerBoxHeight: 54%; //中间盒子的高度287PX
@titBoxHeight: 24%; //title的盒子高度
@introduceBoxHeight: 200px;
@navHeight: 40px;
.titTop {
  // display: ;
  margin-right: 20px;
}

.container {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: rgba(0, 0, 0, 1);
  display: flex;
  align-items: center;
  flex-direction: column;
  header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 9%;
    width: 100%;
    background: url("../../assets/images/pageHome/topTitle.png") no-repeat
      center/100% 100%;
    position: relative;
    .header_content {
      // transform: translateY(-0px);
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fff;
    }
    .pageTime {
      position: absolute;
      top: 2.7%;
      right: 10px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffe1ce;
    }
    .goback {
      color: #fff;
      font-size: 24px;
      position: absolute;
      top: 33.7%;
      right: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
  }
  .center_box {
    width: 96%;
    border-radius: 15px;
    background: RGBA(8, 34, 62, 1);
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 22px 0;
    margin-bottom: 20px;
    margin-top: 15px;
    .titBox {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: @titBoxHeight;
      .bigTit {
        color: #fff;
        font-size: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .smallTit {
        color: rgba(255, 255, 255, 1);
        font-size: 27px;
      }
    }
    .introduceBox {
      width: 95%;
      height: @introduceBoxHeight;
      background: rgba(7, 17, 30, 1);
      // box-shadow: 0px 6px 168px 15px RGBA(215, 117, 19, 0.1) inset;

      display: flex;
      margin-top: 15px;
      .introLeft {
        width: 98%;
        display: flex;
        flex-direction: column;
        .introTit {
          width: 84px;
          height: 40px;
          padding-left: 20px;
          background: url("../../assets/socialOrg/introTit.png") no-repeat
            center/100% 100%;
          display: flex;
          // justify-content: center;
          align-items: center;
          color: rgba(255, 255, 255, 1);
          font-size: 24px;
          margin-top: 20px;
          margin-left: 6px;
          margin-bottom: 20px;
        }
        .introCon {
          width: 98%;
          height: 100px;
          margin-left: 18px;
          // padding:5PX 1%;
          color: #fff;
          font-size: 24px;
          line-height: 30px;
          overflow: auto;
          text-overflow: ellipsis;
          white-space: wrap;
        }
        .introCon::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 0px;
          /*高宽分别对应横竖滚动条的尺寸*/
          height: 0px;
        }

        .introCon::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 6px;
          box-shadow: inset 0 0 0px #efefef;
          -webkit-box-shadow: inset 0 0 0px #efefef;
          /* background: rgba(102, 97, 97, 0.2); */
          background: #efefef;
        }
      }
      .introRight {
        width: 32%;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
      }
    }
  }
  .nav {
    width: 95%;
    height: @navHeight;
    display: flex;
    align-items: center;
    cursor: pointer;
    .navItem {
      width: 336px;
      height: 54px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 28px;
    }
    .rightD {
      background: url("../../assets/socialOrg/leftD.png") no-repeat center/100%
        100%;
    }
    .rightA {
      background: url("../../assets/socialOrg/leftA.png") no-repeat center/100%
        100%;
    }
    .leftD {
      background: url("../../assets/socialOrg/rightD.png") no-repeat center/100%
        100%;
    }
    .leftA {
      background: url("../../assets/socialOrg/rightA.png") no-repeat center/100%
        100%;
    }
  }
  .listBox {
    width: 98%;
    height: 300px;
    background: RGBA(8, 34, 62, 1);
    display: flex;
    // align-items: center;
    justify-content: center;
    margin-top: 20px;
    border-radius: 15px;
    width: 96%;
  }
  .list {
    width: 96%;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 33px;
    .item {
      width: 100%;
      height: 80px;
      background: url("../../assets/socialOrg/listBack.png") no-repeat
        center/100% 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
    }
    .itemWord1 {
      color: #fff;
      font-size: 30px;
      font-weight: 600;
      margin-left: 20px;
      opacity: 0.8;
    }
    .itemWord2 {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 26px;
        height: 28px;
        margin-right: 11px;
      }
      font-size: 28px;
      color: #fff;
      opacity: 0.8;
    }
    .itemWord3 {
      font-size: 39px;
      font-weight: 600;
      color: #ffff;
      margin-right: 20px;
    }
  }
}
.itemT {
  float: left;
  box-sizing: border-box;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  height: 97.5px;
  line-height: 97.5px;
  margin-left: 30px;
}
.table {
  margin: 0 auto;
  width: 95%;
  display: flex;
  flex-direction: column;
  border-top: 0px solid rgba(241, 175, 137, 1);
  font-size: 24px;
  .row {
    width: 99.85%;
    margin-left: 1px;
    height: @rowHeight;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    .item {
      flex: 1;
      height: @rowHeight;
      border-right: 1px solid rgba(255, 255, 255, 0.5);
      display: flex;
      align-items: center;
      color: #fff;
      overflow: hidden;
    }
    .item:last-child {
      flex: 1;
      height: @rowHeight;
      border-right: 0px;
    }
    .itemWord {
      display: flex;
      // margin-left: 15px;
      align-items: center;
      .itemcontent {
        color: rgba(255, 255, 255, 1);
        width: 197px;
        display: flex;
        flex-wrap: wrap;
        margin-left: 30px;
        opacity: 0.6;
        font-size: 23px;
      }
      .itemT {
        // width:125px;
      }
    }
  }
  .bigrow {
    width: 100%;
    height: @bigrowHeight;
    display: flex;
    // border-bottom: 1px solid rgba(241, 175, 137, 1);
    border-right: 0px solid rgba(241, 175, 137, 1);
    border-left: 0px solid rgba(241, 175, 137, 1);
    border-top: 0px solid rgba(241, 175, 137, 1);
    background: url("../../assets/socialOrg/tableImg.png") no-repeat center/100%
      100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .bigrow_tit1 {
      font-size: 36px;
      color: #fff;
      font-weight: 600;
    }
    .bigrow_tit2 {
      display: flex;
      margin-top: 18px;
      align-items: center;
      justify-content: center;
      img {
        width: 26px;
        height: 28px;
        margin-right: 11px;
      }
      font-size: 28px;
      color: #fff;
    }
  }
}
.radarCon {
  width: 300px;
  height: 200px;
  margin-bottom: 5px;
}
</style>
